import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionItemState: Dtos.TrialInstitutionItem & IRegistrationFormState = {
    id: null,
    trialInstitutionId: null,
    trialInstitution: null,
    trialInstitutionItemTemplateId: null,
    trialInstitutionItemTemplate: null,
    version: null,
    collectionInstanceId: null,
    collectionInstance: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    search: "",
    dataEntered: null,
    filesAdded: null
}

export interface ITrialInstitutionItemReduxFormState {
    id: IFieldState<number>,
    trialInstitutionId: IFieldState<number>,
    trialInstitution: IFieldState<Dtos.TrialInstitution>,
    trialInstitutionItemTemplateId: IFieldState<number>,
    trialInstitutionItemTemplate: IFieldState<Dtos.TrialInstitutionItemTemplate>,
    version: IFieldState<string>,
    collectionInstanceId: IFieldState<number>,
    collectionInstance: IFieldState<Dtos.CollectionInstance>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
}
